import axios from "../utils/axios";

// ========== OFFER APIs ==========

// Create new offer
export const createOfferApi = (data) => {
  return axios.post("/api/offers", data);
};

// Get all offers for a restaurant
// export const getOffersApi = (restaurantId) => {
//   return axios.get(`/api/offers/${restaurantId}`);
// };

export const getOffersApi = () => {
  return axios.get(`/api/offers`);
};

// Update offer
export const updateOfferApi = (id, data) => {
  return axios.put(`/api/offers/${id}`, data);
};

// Delete offer
export const deleteOfferApi = (id) => {
  return axios.delete(`/api/offers/${id}`);
};

// Toggle offer status
export const toggleOfferApi = (id) => {
  return axios.patch(`/api/offers/toggle/${id}`);
};